import 'antd/dist/reset.css'; // Ant Design v5 CSS
import '@antv/g2';
import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import ReactDOM from 'react-dom/client';
// import { StrictMode } from 'react';
import App from './App.jsx';
import './refresh.js'
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals.js';
import './index.scss';
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
const root = ReactDOM.createRoot(document.getElementById('root'));
const helmetContext = {};
root.render(
    // <React.StrictMode>
    <HelmetProvider context={helmetContext}>
        <Router
            forceRefresh={true} future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
            }}
        >
            <App />
        </Router>
    </HelmetProvider>
    // {/* </React.StrictMode> */ }

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 